/**
 * 클라이언트 코드에서 가져가지만, 포함해서는 안되는 정보는 이 파일로 보내세요. (`webpack.NormalModuleReplacementPlugin`)
 *
 * @example
 * /\/schema\/.+\/ -> 'utils/void.ts'
 */
export default {};
